import api from "./client";

export interface ConversationDisplay {
  primary_name: string;
  source: string;
  subtitle: string | null;
}

export interface ConversationCurrentCustomer {
  name: string | null;
  email: string | null;
  phone: string | null;
  source: string;
}

export interface ConversationMatchedContact {
  crm_contact_id: string;
  display_name: string | null;
  display_name_source: string | null;
  display_name_confidence: string | null;
  display_name_locked: boolean;
}

export interface ConversationIdentity {
  crm_identity_id: string | null;
  provider: string | null;
  label: string | null;
  confidence: string | null;
}

export interface ConversationSummary {
  analytics_conversation_id: string;
  status: "active" | "closed" | "abandoned" | "escalated";
  channel: string;
  channel_label: string;
  customer_name: string;
  customer_email: string | null;
  customer_phone: string | null;
  started_at: string;
  last_activity_at: string;
  ended_at: string | null;
  message_count: number;
  outcome: string | null;
  sentiment_label: string | null;
  sentiment_status: string;
  sentiment_summary: string | null;
  sentiment_score: number | null;
  sentiment_confidence: number | null;
  sentiment_risk_flags: string[] | null;
  sentiment_llm_provider: string | null;
  sentiment_llm_model: string | null;
  sentiment_prompt_version: string | null;
  booking_id: string | null;
  last_message: string | null;
  last_message_role: "user" | "assistant" | null;
  display?: ConversationDisplay;
  current_customer?: ConversationCurrentCustomer;
  matched_contact?: ConversationMatchedContact | null;
  identity?: ConversationIdentity | null;
  identity_resolution_status?: string | null;
  mismatch_flags?: string[];
}

export interface ConversationMessage {
  message_id: number;
  role: "user" | "assistant";
  content: string;
  timestamp: string;
  message_type: string;
  name: string | null;
}

export interface ConversationsListResponse {
  total: number;
  conversations: ConversationSummary[];
}

export interface ConversationMessagesResponse {
  conversation: ConversationSummary;
  messages: ConversationMessage[];
}

export interface ConversationFilters {
  status?: string;
  channel?: string;
  outcome?: string;
  sentiment?: string;
  needs_attention?: boolean;
  risk_flag?: string;
  limit?: number;
  offset?: number;
}

export async function fetchConversations(filters: ConversationFilters = {}): Promise<ConversationsListResponse> {
  const res = await api.get<ConversationsListResponse>("/conversations/list", {
    params: {
      ...(filters.status && { status: filters.status }),
      ...(filters.channel && { channel: filters.channel }),
      ...(filters.outcome && { outcome: filters.outcome }),
      ...(filters.sentiment && { sentiment: filters.sentiment }),
      ...(filters.needs_attention && { needs_attention: "true" }),
      ...(filters.risk_flag && { risk_flag: filters.risk_flag }),
      limit: filters.limit ?? 25,
      offset: filters.offset ?? 0,
    },
  });
  return res.data;
}

export async function fetchConversationMessages(id: string): Promise<ConversationMessagesResponse> {
  const res = await api.get<ConversationMessagesResponse>(`/conversations/${id}/messages`);
  return res.data;
}
